module.exports = __webpack_public_path__ + "img/09_uk.19197f95.svg";